import React from "react";
import styled from "styled-components";
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#08091f',
    color: '#FFFFFF',
    borderRadius: '12px',
    boxShadow: theme.shadows[1],
    fontFamily: 'DM Sans',
    fontSize: 12,
  },
  arrow: {
    color: '#08091f'
  }
}))(Tooltip);

const TipContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px;
  p {
    font-size: .9rem;
    font-weight: normal;
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  }
  li {
    font-size: .9rem;
    font-weight: normal;
    margin-bottom: 4px;
    span {
      font-weight: bold;
    }
  }
`;

const ChildrenContainer = styled.div`
  p {
    font-weight: 400;
  }
`;

export const DarkTooltip = ({children, title, placement = 'bottom', delay = 1300}) => (
  <CustomTooltip
    arrow
    enterDelay={delay}
    title={
      <TipContent>
        {title}
      </TipContent>
    }
    placement={placement}
  >
    <ChildrenContainer>
      {children}
    </ChildrenContainer>
  </CustomTooltip>
)

